<template>
  <div class="content-wrapper">
    <div
      class="logout-navbar"
      style="position: absolute;
      top: 15px;
      right: 15px;"
    >
      <div
        class="d-flex align-items-center"
        @click="logout"
      >
        <GjIcon
          class="mr-50 rotated"
          name="Signout"
        />
        <span style="cursor: pointer;">{{ $tk('ClientPortal.UserMenu.Logout') }}</span>
      </div>
    </div>
    <div class="content-body">
      <div class="p-4">
        <b-card class="p-4">
          <b-row>
            <b-col sm="6">
              <b-col sm="8">
                <div class="account-create-brand-logo mb-3">
                  <img
                    :src="appLogoImage"
                    alt="logo"
                  >
                </div>
              </b-col>
              <b-col sm="8">

                <b-form-group
                  :label="$tk('ClientPortal.Account.Create.Name')"
                  :invalid-feedback="errors['Name']"
                  :state="errors['Name'] == null ? null : false"
                >
                  <b-form-input
                    v-model="account.Name"
                    type="text"
                    :placeholder="$tk('ClientPortal.Account.Create.NamePlaceholder')"
                  />
                </b-form-group>
              </b-col>
              <!-- <b-col sm="8">
                <b-form-group
                  :label="$tk('ClientPortal.Account.Create.FiscalNumber')"
                  :invalid-feedback="errors['FiscalNumber']"
                  :state="errors['FiscalNumber'] == null ? null : false"
                >
                  <b-form-input
                    v-model="account.FiscalNumber"
                    type="text"
                    :placeholder="$tk('ClientPortal.Account.Create.FiscalNumberPlaceholder')"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="8">
                <b-form-group
                  :label="$tk('ClientPortal.Account.Create.BankAccountNumber')"
                  invalid-feedback="errors['BankAccountNumber']"
                  :state="errors['BankAccountNumber'] == null ? null : false"
                >
                  <b-form-input
                    v-model="account.BankAccountNumber"
                    type="text"
                    :placeholder="$tk('ClientPortal.Account.Create.BankAccountNumberPlaceholder')"
                  />
                </b-form-group>
              </b-col> -->
              <b-col sm="8">
                <b-form-group
                  :label="$tk('ClientPortal.Account.Create.PhoneNumber')"
                  invalid-feedback="errors['PhoneNumber']"
                  :state="errors['PhoneNumber'] == null ? null : false"
                >
                  <b-form-input
                    v-model="account.PhoneNumber"
                    type="text"
                    :placeholder="$tk('ClientPortal.Account.Create.PhoneNumberPlaceholder')"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="8">
                <b-form-group
                  label="Industry"
                >
                  <b-form-select
                    v-model="account.industry"
                    :options="industryOptions"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="8">
                <b-form-checkbox
                  v-model="account.isPublisher"
                >
                  <b-form-group :label="$tk('ClientPortal.Account.Create.ApplyAsPublisher')" />
                </b-form-checkbox>
              </b-col>
              <b-col sm="8">
                <b-form-group
                  v-if="account.isPublisher"
                  :label="$tk('ClientPortal.Account.Create.PropertyUrl')"
                >
                  <b-form-input
                    v-model="account.propertyUrl"
                    type="text"
                    :placeholder="$tk('ClientPortal.Account.Create.PropertyUrlPlaceholder')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="configuration.clientConfiguration.showTermsAndConditions"
                sm="8"
              >
                <b-form-checkbox
                  v-model="account.AcceptTermsAndConditions"
                >
                  <b-form-group
                    :label="$tk('ClientPortal.Account.Create.AgreeToTermsAndConditions')"
                    :invalid-feedback="errors['AcceptTermsAndConditions']"
                    :state="errors['AcceptTermsAndConditions'] == null ? null : false"
                  />
                </b-form-checkbox>

              </b-col>
              <b-col sm="8">
                <div class="text-left py-2">
                  <b-button
                    class="bg-white w-100"
                    variant="primary"
                    size="sm"
                    @click="createAccount(account)"
                  >
                    {{ $tk('ClientPortal.Form.Actions.Create') }}
                  </b-button>
                </div>
              </b-col>

            </b-col>
            <b-col
              sm="6"
              class="d-flex justify-content-center align-items-center"
            >
              <img
                src="@/assets/illustrations/create-account.png"
              >
            </b-col>
          </b-row>
        </b-card>

      </div>
    </div>
  </div>

</template>

<script>
import AccountService from '@/api/client/accounts.service'
import IndustryItemsService from '@/api/admin/industries.service'
import notification from '@/mixins/toastification'
import { mapGetters } from 'vuex'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import { logoutUser } from '../../../../GjirafaFront/script/auth'

export default {
  components: {
    GjIcon,
  },
  mixins: [notification],
  data() {
    return {
      account: {
        industry: null,
      },
      errors: {},
      loading: false,
      saving: false,
      appLogoImage: '',
      industryOptions: [],
    }
  },
  computed: {
    ...mapGetters(['configuration']),
  },
  async mounted() {
    this.appLogoImage = this.$store.getters.landingInfo.imageUrl
    await this.fetchIndustries()
  },
  methods: {
    async fetchIndustries() {
      const allIndustries = await IndustryItemsService.getAdminIndustries()

      const parentIndustries = allIndustries.filter(industry => industry.parentId === 0 || industry.parentId === null)

      this.industryOptions = parentIndustries.map(parent => {
        const children = allIndustries.filter(industry => industry.parentId === parent.id)

        return {
          label: parent.name,
          options: children.map(child => ({
            value: child.id,
            text: child.name,
          })),
        }
      })
    },
    async createAccount(account) {
      try {
        const response = await AccountService.create(account)
        if (response.created) {
          // TODO: Redirect to created account
          this.$router.push(`/${response.id}`)
        } else {
          this.errors = response.errors
          this.error(response.message)
        }
      } catch (error) {
        this.error(error.message)
      }
    },
    logout() {
      localStorage.clear()
      logoutUser('auth-login')
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/views/client/account/account-create.scss';
</style>
